module.exports = __webpack_public_path__ + "static/gallery_wild_6_thumb-c9a22714b9afd5564b76beb67d651503.jpg";